<div class="h-group full-width">
  <button (click)="EditConfig()" type="button" class="btn btn-primary btn-sm"><span class="fas fa-cog"></span></button>
  <button (click)="Open()" type="button" class="btn btn-primary btn-sm"><span class="fas fa-play"></span></button>
    <div class="growable" [innerText]="projectName"></div>
  <div [class.hidden]="!hasWorkflow" [innerText]="'Workflow :'+workflowName"></div>
  <div [class.hidden]="!hasWorkflow" class="h-group label-val">
    <div class="control-label">Status: </div>
    <div [innerText]="stageName"></div>
  </div>
</div>
<div class="h-group full-width split">
  <div class="h-group label-val">
    <div>Created:</div><div class="info" [innerText]="created"></div>
  </div>
  <div class="h-group label-val">
    <div>Modified:</div><div class="info" [innerText]="modified"></div>
  </div>
</div>
